import React, { useEffect, useState } from "react";
import { string } from "prop-types";
import { MobileView } from "react-device-detect";
import { DfpComponent } from "../../ads/dfp-component";
import { get } from "lodash";
import { useSelector } from "react-redux";

import "./sticky-ad.m.css";

const StickyAd = ({ pageType }) => {
  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const networkId = get(qtState, ["config", "ads-config", "network_id"], {});
  let pageConfig = get(qtState, ["config", "ads-config", "ad_slots", pageType], {});
  if (pageType === "story-page" && qtState?.data?.story?.["story-template"] !== "text") {
    pageConfig = get(qtState, ["config", "ads-config", "ad_slots", qtState?.data?.story?.["story-template"]], {});
  } else if (qtState?.data?.section?.slug.includes("photos")) {
    pageConfig = get(qtState, ["config", "ads-config", "ad_slots", "photo-listing"], {});
  } else if (qtState?.data?.section?.slug.includes("videos")) {
    pageConfig = get(qtState, ["config", "ads-config", "ad_slots", "video-listing"], {});
  }
  const stickyAdUnit = get(pageConfig, ["mobile", "sticky_ad", "ad_unit"], "");
  const [adComponent, setAdComponent] = useState();

  useEffect(() => {
    setAdComponent(
      stickyAdUnit && (
        <MobileView>
          <DfpComponent
            id={`${pageType}-sticky_ad`}
            path={`/${networkId}/${stickyAdUnit}`}
            adSlotConfigName={"320x50_ad"}
            showText={false}
          />
        </MobileView>
      )
    );
  }, []);
  return <div styleName="sticky-ad">{adComponent}</div>;
};
StickyAd.propTypes = {
  pageType: string,
};
export default StickyAd;
